// NPM Imports
import React, { Fragment, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

// Component Imports
import { OnBoardPopUp } from "../../../commonComponents";

export default function NavBarItemUpgrade(props) {
  // * LOCAL STATE DECLARATION SYNTAX
  const [showPopUp, togglePopUp] = useState(false);

  const { item } = props;
  return (
    <Fragment>
      <div
        onClick={() => togglePopUp(true)}
        onKeyDown={() => togglePopUp(true)}
        data-test="navbar-item navbar-item-tnb"
        className="navbar-item"
        id={`top-navbar-item-${item.name}`}
        role="button"
        tabIndex={0}>
        <i className="navbar-icon">
          <FontAwesomeIcon icon={["far", `${item.ico}`]} />
          <span className="navbar-item-upgrade-label">PRO</span>
        </i>
        <span className="navbar-title">{item.tooltip}</span>
      </div>

      {/* UPGRADE POPUP SECTION */}
      {showPopUp && (
        <OnBoardPopUp
          featureName={item.featureGating.name}
          onClose={() => togglePopUp(false)}
        />
      )}
    </Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/components/NavBarWrapper/NavBar/NavBarItemUpgrade.js